import { useMutation } from '@apollo/client';

import { useParams } from 'react-router-dom';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';

import { notificationService } from '@/services/notification/notification.client';
import GetVarBillingUsageDetailsQuery from '@/graphql/contracts//getVarBillingUsageDetails.query.gql';
import GetVarBillingUsageHeaderQuery from '@/graphql/contracts//getVarBillingUsageHeader.query.gql';
import ProcessUsageDetailsMutation from '@/graphql/contracts/processUsageDetails.mutation.gql';

import { USAGE_RECORDS_PER_PAGE } from '@/config/common.config';
import { ProcessUsageDetails, ProcessUsageDetailsVariables } from
  '@/graphql/contracts/_generated_/processUsageDetails.mutation';
import { ProcessUsageDetailsInputType } from '@/graphql/contracts/_generated_/contracts';

export default function useProcessUsageDetails() {
  const { fileId }: { fileId: string } = useParams();
  const [_processUsageDetails, { loading }] = useMutation<ProcessUsageDetails, ProcessUsageDetailsVariables>(
    ProcessUsageDetailsMutation,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
    },
  );


  const processUsageDetails = (usageHeader: ProcessUsageDetailsInputType, successCb?: () => void) => {
    _processUsageDetails({
      variables: { input: usageHeader },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetVarBillingUsageDetailsQuery,
          variables: {
            first: USAGE_RECORDS_PER_PAGE,
            filter: {
              headerPrimaryKey: { eq: usageHeader.usageHeaderId }
            },
          },
        },
        {
          query: GetVarBillingUsageHeaderQuery,
          variables: {
            id: fileId
          },
        },
      ],
      onCompleted: () => {
        successCb?.();
        notificationService.open({
          title: 'Sales Order Generation',
          text: 'Sales order generation is in progress...',
          type: 'warning'
        });
      }
    });
  };

  return {
    processUsageDetails,
    isProcessUsageDetailsLoading: loading,
  } as const;
}
